<template>
  <div style="margin: 15px; margin-right: 30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="60px">
      <el-form-item label="姓名" prop="userName">
        <el-input v-model.trim="form.userName" placeholder="请输入姓名" clearable />
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入电话" clearable />
      </el-form-item>
      <el-form-item label="角色" prop="staffRole">
        <el-input v-model="form.staffRole" placeholder="请选择角色" clearable @clear="clearRole" @focus="selsectRole()" />
        <el-input v-show="false" v-model="form.roleCode" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>

    <vxe-modal v-model="role" title="选择角色" width="900" height="800" resize>
      <roleList ref="roleRef" @event="receiveRole" />
    </vxe-modal>
  </div>
</template>
<script>
import { addShipmentStaff } from "@/api/shipment";
import { validatePhone } from "@/utils/validate.js";
import roleList from "./components/roleList";
export default {
  name: "ShipmentStaffAdd",
  components: {
    roleList,
  },
  props: {
    staffTypeOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    companyCode: {
      type: String,
      default() {
        return "";
      },
    },
    branchCode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      role: false,
      form: {
        userName: "",
        phone: "",
        staffType: "",
        staffRole: "",
        roleCode: "",
      },
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符" },
        ],
        phone: [
          {
            required: true,
            validator(rule, value, callback) {
              validatePhone(value)
                ? callback()
                : callback(new Error("手机号格式有误"));
            },
            trigger: "blur",
          },
        ],
        staffRole: [
          { required: true, message: "请选择角色", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  methods: {
    clearRole() {
      this.form.staffRole = "";
      this.form.roleCode = "";
    },
    // 选择角色
    selsectRole() {
      this.form.branchCode = this.branchCode
      this.$refs.roleRef.findList(this.form)
      this.role = true;
    },
    receiveRole(data) {
      this.role = false;
      this.form.staffRole = data.roleName;
      this.form.roleCode = data.code;
      this.form.shipmentRoleType = data.role;
      let shipmentRoleType = this.staffTypeOptions.find((item) => data.role == item.role) || [];
      this.form.ApiModelProperty = shipmentRoleType.role || 10;
    },
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const rLoading = this.openLoading();
          var data = Object.assign({}, this.form, {
            companyCode: this.companyCode,
          });
          addShipmentStaff(data)
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}


</style>
